import { render, staticRenderFns } from "./koutu.vue?vue&type=template&id=a2224f58"
import script from "./koutu.vue?vue&type=script&lang=js"
export * from "./koutu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports